import { View } from '../compiler'

import { colors, typoStyles } from '../constants'
import MarkdownText from './MarkdownText'

const RowListItem = ({ Icon, text }) => {
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        columnGap: 16
      }}
    >
      <Icon style={{ width: 16, height: 16 }} color={colors.primaryBlue} />
      <View style={{ width: '88%' }}>
        <MarkdownText style={typoStyles.T1Black}>{text}</MarkdownText>
      </View>
    </View>
  )
}

export default RowListItem
